module.exports = __webpack_public_path__ + "img/service-254.08c36b67.png";